import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { WorkerFattureAttiveModalComponent } from './worker-fatture-attive-modal';

export const WorkerFattureAttiveModalModule: string = ng
    .module('worker-fatture-attive-modal', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('workerFattureAttiveModalComponent', WorkerFattureAttiveModalComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/conservazione/component/worker-fatture-attive-modal/worker-fatture-attive-modal.module.ts